// clientapp/src/components/AppSnackbarContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';
// Import this component below or in a separate file
import AppSnackbar from './../components/AppSnackbar';

const AppSnackbarContext = createContext();

export function useAppSnackbar() {
    return useContext(AppSnackbarContext);
}

export function AppSnackbarProvider({ children }) {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('info');

    const showSnackbar = useCallback((msg, sev = 'info') => {
        setMessage(msg);
        setSeverity(sev);
        setOpen(true);
    }, []);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpen(false);
    };

    return (
        <AppSnackbarContext.Provider value={{ showSnackbar }}>
            {children}
            <AppSnackbar
                open={open}
                message={message}
                severity={severity}
                onClose={handleClose}
            />
        </AppSnackbarContext.Provider>
    );
}

